<div class="fab-button" [id]="id" (click)="!isDisabled ? clickButton($event) : ''">
  <mat-progress-spinner *ngIf="hasSpinner && spinnerValues[id] < 100" class="example-margin" color="primary"
    [mode]="spinnerMode ? spinnerMode : 'determinate'" [value]="spinnerValues[id] || 0" [diameter]="isLarge ? 56 : 40"
    [strokeWidth]="isLarge ? 3 : 2">
  </mat-progress-spinner>

  <div *ngIf="!isLarge">
    <button mat-mini-fab [color]="color ? color : 'accent'" [disabled]="isDisabled" class="mat-elevation-z"
      [ngClass]="class ? class : ''" fxLayout="row" fxLayoutAlign="center center">
      <mat-icon>{{icon ? icon : 'done'}}</mat-icon>
    </button>
  </div>

  <div *ngIf="isLarge">
    <button mat-fab [color]="color ? color : 'accent'" [disabled]="isDisabled" class="mat-elevation-z"
      [ngClass]="class ? class : ''" fxLayout="row" fxLayoutAlign="center center">
      <mat-icon>{{icon ? icon : 'done'}}</mat-icon>
    </button>
  </div>
</div>
